/* eslint-disable */

/** unique or primary key constraints on table "argo.material_status_history" */
export enum ArgoMaterialStatusHistoryConstraint {
  /** unique or primary key constraint on columns "material_status_history_id" */
  MaterialActivityPkey = 'material_activity_pkey'
}

/** select columns of table "argo.material_status_history" */
export enum ArgoMaterialStatusHistorySelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  MaterialStatusHistoryId = 'material_status_history_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Status = 'status'
}

/** update columns of table "argo.material_status_history" */
export enum ArgoMaterialStatusHistoryUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  MaterialStatusHistoryId = 'material_status_history_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Status = 'status'
}

